import { useState } from 'react';
import { Share2, MessageCircle, Facebook, Twitter, Link2, X } from 'lucide-react';
import { toast } from 'sonner';

const ShareButton = () => {
  const [open, setOpen] = useState(false);

  const url = typeof window !== 'undefined' ? window.location.origin : '';
  const shareText = encodeURIComponent("Découvrez Grace TV Gospel — la chaîne gospel chrétienne en continu !");
  const encodedUrl = encodeURIComponent(url);

  const links = [
    {
      label: 'WhatsApp',
      icon: <MessageCircle size={18} />,
      href: `https://wa.me/?text=${shareText}%20${encodedUrl}`,
      testid: 'share-whatsapp',
      cls: 'share-whatsapp',
    },
    {
      label: 'Facebook',
      icon: <Facebook size={18} />,
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      testid: 'share-facebook',
      cls: 'share-facebook',
    },
    {
      label: 'X (Twitter)',
      icon: <Twitter size={18} />,
      href: `https://twitter.com/intent/tweet?text=${shareText}&url=${encodedUrl}`,
      testid: 'share-twitter',
      cls: 'share-twitter',
    },
  ];

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success('Lien copié dans le presse-papiers');
      setOpen(false);
    } catch {
      toast.error('Impossible de copier le lien');
    }
  };

  return (
    <div className="share-fab-wrap" data-testid="share-fab-wrap">
      {open && (
        <div className="share-fab-menu" data-testid="share-fab-menu">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              target="_blank"
              rel="noopener noreferrer"
              className={`share-fab-item ${l.cls}`}
              data-testid={l.testid}
              onClick={() => setOpen(false)}
            >
              {l.icon}
              <span>{l.label}</span>
            </a>
          ))}
          <button
            type="button"
            onClick={copyLink}
            className="share-fab-item share-copy"
            data-testid="share-copy-link"
          >
            <Link2 size={18} />
            <span>Copier le lien</span>
          </button>
        </div>
      )}
      <button
        type="button"
        className="share-fab-button"
        onClick={() => setOpen((o) => !o)}
        aria-label={open ? 'Fermer le menu de partage' : 'Partager la chaîne'}
        data-testid="share-fab-button"
      >
        {open ? <X size={20} /> : <Share2 size={20} />}
      </button>
    </div>
  );
};

export default ShareButton;
